<template>
  <section class="hero is-default is-bold">
    <div class="hero-body">
      <div class="container" style="margin-top: -60px">
        <div class="columns is-vcentered">
          <div class="column is-6 mt-50">
            <img
              style="box-shadow: 0 2px 29px 0 rgba(68, 88, 144, 0.12)"
              src="@/assets/notauthorized.jpg"
            />
          </div>
          <div class="column is-6 has-text-centered">
            <p
              style="
                font-size: 26px;
                font-weight: 300;
                font-family: 'Poppins', sans-serif;
                color: #2a2c39;
              "
            >
              Sorry, an error has occured.
              <br />
              You'are not authorized to access this resource
              <br /><br />
            </p>
            <button
              class="button is-primary"
              @click="$router.push('/')"
              type="submit"
            >
              <span class="icon is-small"><i class="fa fa-home"></i></span>
              <span>Take me home</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'NotFound'
}
</script>
